import { render, staticRenderFns } from "./VndTransactions.vue?vue&type=template&id=db4bd5b6&"
import script from "./VndTransactions.vue?vue&type=script&lang=ts&"
export * from "./VndTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports